<template>
  <el-row class="h-full">
    <el-col :span="19" class="h-border h-left">
      <el-row class="grid-content charts-wrap">
        <el-col id="editable_chart" :offset="1" :span="22" class="editable_chart"></el-col>
      </el-row>
    </el-col>
    <el-col :span="5" class="h-border h-right">
      <el-form ref="form" :model="form" label-width="70px" class="e-form-wrap" label-position="left" size="mini">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick" class="tabs-wrap">
          <el-tab-pane label="图表数据" name="1" class="tab-pane">
            <el-row class="tab-top-btn-wrap">
              <i class="el-icon-document-add add-from-base data-icon" @click='handleAddData'>从库中添加数据</i>
              <i class="el-icon-sort change-data data-icon" @click="handleReserve">横纵数据转换</i>
            </el-row>
            <div class="hot-table-wrap">
              <hot-table :settings="settings" licenseKey="non-commercial-and-evaluation" ref="container"></hot-table>
            </div>
            <div class="tab-bottom-btn-wrap">
              <el-button type="primary" @click="handleSubmit('data')">保存</el-button>
              <el-button @click="handleCancel('data')" autofocus>取消</el-button>
            </div>

          </el-tab-pane>
          <el-tab-pane label="显示配置" name="2" class="tab-pane">
            <div class="form-wrap">
              <div class="f-title">标题</div>
              <el-form-item label="标题内容">
                <el-input v-model="form.title"></el-input>
              </el-form-item>
              <el-form-item label="是否显示">
                <el-switch v-model="form.title_show"></el-switch>
              </el-form-item>
              <el-form-item label="数值是否显示">
                <el-switch v-model="form.label_show"></el-switch>
              </el-form-item>
              <el-form-item label="标题颜色">
                <el-color-picker v-model="form.title_color" :predefine="form.predefineColors"></el-color-picker>
              </el-form-item>
              <el-form-item label="标题字号">
                <el-select v-model="form.title_font_size" placeholder="请选择">
                  <el-option key="8" label="8" value="8">
                  </el-option>
                  <el-option key="10" label="10" value="10">
                  </el-option>
                  <el-option key="12" label="12" value="12">
                  </el-option>
                  <el-option key="14" label="14" value="14">
                  </el-option>
                  <el-option key="16" label="16" value="16">
                  </el-option>
                </el-select>
              </el-form-item>
              <div class="f-title">图例</div>
              <el-form-item label="图表类型">
                <i @click="handleType('bar')" :class="form.graphics_type=='bar'?'type-active':''" class="el-icon-s-data bar-icon type-icon"></i>
                <i @click="handleType('line')" :class="form.graphics_type=='line'?'type-active':''" class="el-icon-s-marketing line-icon type-icon"></i>
              </el-form-item>
              <div class="f-title">x轴</div>
              <el-form-item label="轴名称">
                <el-input v-model="form.xAxis_name"></el-input>
              </el-form-item>
              <el-form-item label="是否显示">
                <el-switch v-model="form.xAxis_show"></el-switch>
              </el-form-item>
              <el-form-item label="分割线是否显示">
                <el-switch v-model="form.divider_show"></el-switch>
              </el-form-item>
              <el-form-item label="分割线类型">
                <el-select v-model="form.divider_type" placeholder="请选择">
                  <el-option key="实线" label="实线" value="solid">
                  </el-option>
                  <el-option key="虚线" label="虚线" value="dashed">
                  </el-option>
                </el-select>
              </el-form-item>
              <div class="f-title">y轴</div>
              <el-form-item label="轴名称">
                <el-input v-model="form.yAxis_name"></el-input>
              </el-form-item>
              <el-form-item label="是否显示">
                <el-switch v-model="form.yAxis_show"></el-switch>
              </el-form-item>
              <el-form-item label="最大值">
                <el-input-number v-model="form.yAxis_max" controls-position="right" @change="handleChangeMax"></el-input-number>
              </el-form-item>
              <el-form-item label="最小值">
                <el-input-number v-model="form.yAxis_min" controls-position="right" @change="handleChangeMin"></el-input-number>
              </el-form-item>
              <el-form-item label="数据类型">
                <el-select v-model="form.data_type" placeholder="请选择" @change="handleChangeDataType">
                  <el-option key="0" label="数字" value="数字">
                  </el-option>
                  <el-option key="1" label="百分比" value="百分比">
                  </el-option>
                </el-select>
              </el-form-item>
              <div class="f-title">填充</div>
              <el-form-item label="配色类别">
                <el-select v-model="form.color_type" placeholder="请选择">
                  <el-option v-for="(item,index) in color_type_arr" :key="index" :label="item" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="颜色">
                <el-color-picker v-model="form.color" @change="handleColorType" :predefine="form.predefineColors"></el-color-picker>
              </el-form-item>
            </div>
            <div class="tab-bottom-btn-wrap">
              <el-button type="primary" @click="handleSubmit('config')">保存</el-button>
              <el-button @click="handleCancel('config')" autofocus>取消</el-button>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-form>
      </div>
    </el-col>
  </el-row>
</template>
<style>
@import '../../../node_modules/handsontable/dist/handsontable.full.css';
.h-full {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.h-border {
  border: 1px solid #ccc;
  border-bottom: 0;
  border-right: 0;
}

.h-left {
  height: 100%;
}

.h-right {
  height: 100%;

  background-color: #fafafb;
}

.charts-wrap {
  position: absolute;
  top: 55px;
  bottom: 0;
  left: 0;
  right: 20.8%;
}

.charts-wrap .editable_chart {
  border: 1px solid #ccc;
  padding: 20px;
  height: 85%
}

.tab-top-btn-wrap {
  text-align: center;
  height: 60px;
  line-height: 60px;
}

.tab-top-btn-wrap .data-icon {
  font-size: 15px;
  color: #666;
  cursor: pointer;
}

.tab-top-btn-wrap .add-from-base {
  margin-right: 10px;
}

.tab-top-btn-wrap .change-data {}

.e-form-wrap {
  height: 100%;
  text-align: left;
}

.tabs-wrap {
  height: 100%;
  position: relative;
}

.el-tabs__content {
  position: absolute;
  top: 55px;
  bottom: 0;
  left: 0;
  right: 0;
}

.el-tab-pane {
  position: relative;
  height: 100%;
}

.el-tab-pane .hot-table-wrap {
  position: absolute;
  top: 60px;
  bottom: 10%;
  left: 0;
  right: 0;
  overflow: auto;
  margin: 0 20px;
}

.tab-bottom-btn-wrap {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 10%;
  border-top: 1px solid #ccc;
  display: flex;
  justify-content: center;
  align-items: Center;
}

.form-wrap {
  position: absolute;
  top: 0px;
  bottom: 10%;
  left: 0;
  right: 0;
  overflow-y: auto;
  padding: 20px;
}

.f-title {
  font-size: 15px;
  font-weight: bold;
  color: #000;
}

.el-form-item--mini.el-form-item {
  width: 60%;
  margin: 0 auto 10px;
}

.type-icon {
  display: inline-block;
  cursor: pointer;
  font-size: 24px;
  margin-right: 10px;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  background-color: #f0f0f0;
}

.type-active {
  color: orange;
}

.handsontable tr:first-child td {
  background-color: #f0f0f0;
}

.el-tabs--card>.el-tabs__header {}

.el-tabs--card>.el-tabs__header .el-tabs__nav {
  border: none;
}

.el-tabs--card>.el-tabs__header {
  margin: 0;
  height: 55px;
  line-height: 55px;
  text-align: center;
  border: none;
  border-bottom: 1px solid #E4E7ED;
  display: flex;
  justify-content: center;
  align-items: Center;
}

.el-tabs--card>.el-tabs__header .el-tabs__item:first-child.is-active {
  border: none;
}

.el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
  border: none;
  border-left: 1px solid #E4E7ED;
}

.h-input {
  -webkit-appearance: none;
  background-color: #FFF;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 40px;
  line-height: 40px;
  outline: 0;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  width: 100%;
  height: 28px;
  line-height: 28px;
}
</style>
<script>
// 引入所有的echarts图表打包，体积会过大，这里按需引入
// 引入基本模板
let echarts = require('echarts/lib/echarts')
// 引入柱状图组件
import 'echarts/lib/chart/bar';
// 引入折线图。
import 'echarts/lib/chart/line';
// 引入提示框和title组件
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend';
import { HotTable } from '@handsontable/vue';
import 'handsontable/languages/zh-CN';

export default {
  name: 'EditableChart',
  props: ["handleAddDataFn", "handleCancelFn", "handleSubmitFn", "dataSource", "handleChangeDataTypeFn"],
  data() {
    var _this = this;
    let cur_data = this.dataSource.data;
    if (!cur_data || cur_data.length == 0) {
      cur_data = [[]]
    }
    return {
      id: this.dataSource.id,
      activeName: '1',
      settings: {
        data: cur_data,
        colWidths: 100,//固定列宽
        rowHeaders: true,
        colHeaders: false,
        fixedRowsTop: 1,
        fixedColumnsLeft: 1,
        licenseKey: 'non-commercial-and-evaluation',
        afterChange: function(changes, source) {
          if (source != "loadData") {//编辑了，当table内容改变时重绘图表
            _this.settings.data = _this.hot_table.getData();
            _this.drawLine(1);
            _this.resetY(_this.dataSource.config);
          }
        },
        afterRemoveCol: function(index, amount, physicalColumns, source) {
          _this.settings.data = _this.hot_table.getData();
          _this.remove_col_flag = true;
          _this.drawLine(1);
        },
        afterRemoveRow: function(index, amount, physicalColumns, source) {
          _this.settings.data = _this.hot_table.getData();
          _this.drawLine(1);
        },
        minCols: 20,
        minRows: 30,
        language: 'zh-CN',//汉化
        contextMenu: true,//右键显示上下文菜单
        contextMenu: {//定制上下文菜单
          items: {
            row_above: {
              name: "单元格上方插入行"
            },
            row_below: {
              name: "单元格下方插入行"
            },
            hsep1: "---------",
            col_left: {
              name: "单元格左侧插入列"
            },
            col_right: {
              name: "单元格右侧插入列"
            },
            hsep2: "---------",
            remove_row: {
              name: "删除行"
            },
            remove_col: {
              name: "删除列"
            }
          }
        },
      },
      form: {
        title: (this.dataSource.config && this.dataSource.config.title) || '请输入视图标题',
        title_show: (this.dataSource.config && this.dataSource.config.title_show) || true,
        title_color: (this.dataSource.config && this.dataSource.config.title_color) || "#404349",
        title_font_size: (this.dataSource.config && this.dataSource.config.title_font_size) || 16,
        xAxis_name: (this.dataSource.config && this.dataSource.config.xAxis_name) || "",
        xAxis_show: (this.dataSource.config && this.dataSource.config.xAxis_show) || false,
        divider_show: (this.dataSource.config && this.dataSource.config.divider_show) || false,//分割线是否显示
        divider_type: (this.dataSource.config && this.dataSource.config.divider_type) || "solid",//分割线类型，solid,dashed
        yAxis_name: (this.dataSource.config && this.dataSource.config.yAxis_name) || "",
        yAxis_show: (this.dataSource.config && this.dataSource.config.yAxis_show) || false,
        yAxis_min: (this.dataSource.config && this.dataSource.config.yAxis_min) || "dataMin",//y轴最小值,默认为"dataMin"自动计算最小值
        yAxis_max: (this.dataSource.config && this.dataSource.config.yAxis_max) || "dataMax",//y轴最大值，默认为"dataMax"自动计算最大值
        data_type: (this.dataSource.config && this.dataSource.config.data_type) || "数字",//y轴-数据类型
        color_type: (this.dataSource.config && this.dataSource.config.color_type) || "",//填充-配色类别，手动选择，默认为“”即可
        color: (this.dataSource.config && this.dataSource.config.color) || "",//填充-默认颜色
        predefineColors: (this.dataSource.config && this.dataSource.config.predefineColors) || [
          '#ff4500',
          '#ff8c00',
          '#ffd700',
          '#90ee90',
          '#00ced1',
          '#1e90ff',
          '#c71585',
          'rgba(255, 69, 0, 0.68)',
          'rgb(255, 120, 0)',
          'hsv(51, 100, 98)',
          'hsva(120, 40, 94, 0.5)',
          'hsl(181, 100%, 37%)',
          'hsla(209, 100%, 56%, 0.73)',
          '#c7158577'
        ],
        graphics_type: (this.dataSource.config && this.dataSource.config.graphics_type) || 'bar',
        label_show: (this.dataSource.config && this.dataSource.config.label_show) || false
      },
      ui_color: (this.dataSource.config && this.dataSource.config.ui_color) || ['#ff8a43', '#5a8cff', '#ffb65e', '#ea532e', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'],
      remove_col_flag: false,//当前操作是否是移除的列
      remove_row_flag: false,
      mounted_flag: false,//当前是否是mounted
      color_type_arr: [],
      handleAddData: this.handleAddDataFn,
      handleCancel: this.handleCancelFn,
      handleSubmit: this.handleSubmitFn,
      changeMaxTimes: 0,
      changeMinTimes: 0,
      hasPercentSymbol: 0
    }
  },
  components: {
    HotTable
  },
  computed: {
    dataSource_data() {
      return this.dataSource.data
    },
    dataSource_config() {
      return this.dataSource.config
    },
  },
  watch: {
    dataSource_data: {//原数据data变化
      deep: true,
      handler: function(val, oldVal) {
        if (!this.remove_col_flag && !this.mounted_flag && !this.remove_row_flag) {
          this.changeMaxTimes = 0;
          this.changeMinTimes = 0
          let cur_data = val;
          let cur_config = this.dataSource.config;
          if (!cur_data || cur_data.length == 0) {
            cur_data = [[]]
          }
          this.settings.data = cur_data;
          this.resetY(cur_config);
          this.id = val.id;
          this.hot_table.updateSettings({
            data: cur_data
          });
          this.drawLine(1);
        } else {
          if (this.remove_col_flag) {
            this.remove_col_flag = false;
          }
          if (this.remove_row_flag) {
            this.remove_row_flag = false;
          }
          if (this.mounted_flag) {
            this.mounted_flag = false;
          }
        }
      },
    },

    dataSource_config: {//原数据config变化
      deep: true,
      handler: function(val, oldVal) {
        if (!this.remove_col_flag && !this.mounted_flag && !this.remove_row_flag) {
          this.changeMaxTimes = 0;
          this.changeMinTimes = 0
          let cur_data = this.dataSource.data;
          let cur_config = val;
          if (!cur_data || cur_data.length == 0) {
            cur_data = [[]]
          }
          this.settings.data = cur_data;
          this.resetForm(cur_config);
          this.id = val.id;
          this.hot_table.updateSettings({
            data: cur_data
          });
          this.drawLine(1);
        } else {
          if (this.remove_col_flag) {
            this.remove_col_flag = false;
          }
          if (this.remove_row_flag) {
            this.remove_row_flag = false;
          }
          if (this.mounted_flag) {
            this.mounted_flag = false;
          }
        }
      },
    },


    form: {//深度监听，可监听到对象、数组的变化,当form表单内容改变时重绘图表
      deep: true,
      handler: function(val, oldVal) {
        let cur_color_arr = this.editable_chart.getOption().color;
        let cur_color_index = this.color_type_arr.indexOf(this.form.color_type);
        if (this.hasChangeColorType) {
          cur_color_arr[cur_color_index] = this.form.color;
          this.ui_color = cur_color_arr;
          this.hasChangeColorType = false
        } else {
          this.form.color = cur_color_arr[cur_color_index];
        }
        this.drawLine();
      },
    },

  },
  mounted() {
    this.mounted_flag = true;
    this.hot_table = this.$refs.container.hotInstance;
    this.editable_chart = echarts.init(document.getElementById('editable_chart'));
    this.drawLine(1);
    window.onresize = () => {
      this.editable_chart.resize();
    }
  },
  methods: {
    resetY(cur_config) {
      this.form.yAxis_min = (cur_config && cur_config.yAxis_min + "") || "dataMin";//y轴最小值,默认为"dataMin"自动计算最小值
      this.form.yAxis_max = (cur_config && cur_config.yAxis_max + "") || "dataMax";//y轴最大值，默认为"dataMax"自动计算最大值
    },
    resetForm(cur_config) {
      this.form = {
        title: (cur_config && cur_config.title) || '请输入视图标题',
        title_show: (cur_config && cur_config.title_show) || true,
        title_color: (cur_config && cur_config.title_color) || "#404349",
        title_font_size: (cur_config && cur_config.title_font_size) || 16,
        xAxis_name: (cur_config && cur_config.xAxis_name) || "",
        xAxis_show: (cur_config && cur_config.xAxis_show) || false,
        divider_show: (cur_config && cur_config.divider_show) || false,//分割线是否显示
        divider_type: (cur_config && cur_config.divider_type) || "solid",//分割线类型，solid,dashed
        yAxis_name: (cur_config && cur_config.yAxis_name) || "",
        yAxis_show: (cur_config && cur_config.yAxis_show) || false,
        yAxis_min: (cur_config && cur_config.yAxis_min + "") || "dataMin",//y轴最小值,默认为"dataMin"自动计算最小值
        yAxis_max: (cur_config && cur_config.yAxis_max + "") || "dataMax",//y轴最大值，默认为"dataMax"自动计算最大值
        data_type: (cur_config && cur_config.data_type) || "数字",//y轴-数据类型
        color_type: (cur_config && cur_config.color_type) || "",//填充-配色类别，手动选择，默认为“”即可
        color: (cur_config && cur_config.color) || "",//填充-默认颜色
        predefineColors: (cur_config && cur_config.predefineColors) || [
          '#ff4500',
          '#ff8c00',
          '#ffd700',
          '#90ee90',
          '#00ced1',
          '#1e90ff',
          '#c71585',
          'rgba(255, 69, 0, 0.68)',
          'rgb(255, 120, 0)',
          'hsv(51, 100, 98)',
          'hsva(120, 40, 94, 0.5)',
          'hsl(181, 100%, 37%)',
          'hsla(209, 100%, 56%, 0.73)',
          '#c7158577'
        ],
        graphics_type: (cur_config && cur_config.graphics_type) || 'bar',
        label_show: (cur_config && cur_config.label_show) || false
      };
      this.ui_color = (cur_config && cur_config.ui_color) || ['#ff8a43', '#5a8cff', '#ffb65e', '#ea532e', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'];
    },
    //绘制图表
    drawLine(need_clear) {
      // 基于准备好的dom，初始化echarts实例
      var _this = this;
      //百分比数据处理
      let source_data = this.deal_data(this.settings.data);
      //dimensions 定义 series.data 或者 dataset.source 的每个维度的信息。
      //注意：如果使用了 dataset，那么可以在 dataset.source 的第一行/列中给出 dimension 名称。于是就不用在这里指定 dimension。
      //但是，如果在这里指定了 dimensions，那么 ECharts 不再会自动从 dataset.source 的第一行/列中获取维度信息。
      let sd0 = source_data[0], dim = [];
      for (let i = 0; i < sd0.length; i++) {
        if (sd0[i] !== null) {
          dim.push(sd0[i]);
        }
      }
      dim[0] = "";
      // 绘制图表
      var cur_legend = [];
      for (let i = 0; i < dim.length; i++) {
        if (dim[i]) {
          cur_legend.push(dim[i])
        }
      }
      this.color_type_arr = cur_legend;
      var cur_series = [];
      for (let j = 0; j < cur_legend.length; j++) {
        cur_series.push({
          type: this.form.graphics_type,
          dimensions: dim,
          label: {
            show: this.form.label_show,
            position: "top",
            formatter: function(datas) {
              var res = '';
              res = datas.data[datas.seriesIndex + 1];
              if (_this.form.data_type === "百分比") {
                if (_this.hasPercentSymbol > 0) {//原数据是百分比，使用原数据
                  res = datas.data[datas.seriesIndex + 1] + "%";
                } else {
                  res = _this.formatFloat(datas.data[datas.seriesIndex + 1] * 100, 2) + "%";
                }

              }
              return res
            }
          }
        })
      }

      if (need_clear) {
        this.editable_chart.clear();
      }

      this.editable_chart.setOption({
        color: this.ui_color,
        title: {
          text: this.form.title,
          left: "center",
          show: this.form.title_show,
          textStyle: {
            color: this.form.title_color,
            fontSize: this.form.title_font_size,
          }
        },
        legend: {
          x: 'center', // 'center' | 'left' | {number},
          y: 'bottom', // 'center' | 'bottom' | {number}
          data: cur_legend
        },

        tooltip: {
          formatter: function(datas) {
            var res = '';
            res += datas.seriesName + '<br/>'
              + datas.marker + datas.name + ":" + datas.data[datas.seriesIndex + 1];
            if (_this.form.data_type === "百分比") {
              if (_this.hasPercentSymbol > 0) {//原数据是百分比，使用原数据
                res = datas.seriesName + '<br/>'
                  + datas.marker + datas.name + ":" + datas.data[datas.seriesIndex + 1] + "%";
              } else {
                res = datas.seriesName + '<br/>'
                  + datas.marker + datas.name + ":" + _this.formatFloat(datas.data[datas.seriesIndex + 1] * 100, 2) + "%";
              }

            }
            return res
          }
        },
        dataset: {
          // 提供一份数据。
          source: source_data
        },
        // 声明一个 X 轴，类目轴（category）。默认情况下，类目轴对应到 dataset 第一列。
        xAxis: {
          name: this.form.xAxis_show ? this.form.xAxis_name : "",
          type: 'category',
          axisTick: {
            alignWithLabel: true//坐标轴刻度与标签对齐
          },
          splitLine: {//分割线
            show: this.form.divider_show,
            lineStyle: {
              type: this.form.divider_type,
            }

          },
        },
        // 声明一个 Y 轴，数值轴。
        yAxis: {
          name: this.form.yAxis_show ? this.form.yAxis_name : "",
          min: this.form.yAxis_min,
          max: this.form.yAxis_max,
          axisLabel: {
            formatter: function(datas) {
              let res;
              if (_this.form.data_type === "百分比") {
                if (_this.hasPercentSymbol > 0) {//原数据是百分比，使用原数据
                  res = datas + '%';
                } else {
                  res = _this.formatFloat(datas * 100, 2) + '%';
                }
              } else {
                res = datas;
              }
              return res
            }
          }
        },
        // 声明多个 bar 系列，默认情况下，每个系列会自动对应到 dataset 的每一列。
        series: cur_series

      });
    },
    deal_data() {//数据处理
      // //需要被转置的数组
      // this.has_percent = 0;
      var arr1 = this.settings.data;
      //定义一个新的数组
      var arr2 = [];
      var data_part = []
      //对新的数组进行初始化
      //因为新的数组的列数都等于原来数组列的数量
      for (let i = 0; i < arr1.length; i++) {
        arr2[i] = [];
        if (i > 0) {
          data_part[i] = [];
        }
      }

      //开始进行数组的转置
      this.hasPercentSymbol = 0
      for (var i = 0; i < arr1.length; i++) {
        for (var j = 0; j < arr1[i].length; j++) {
          if (i == 0 || j == 0) {
            arr2[i][j] = arr1[i][j];
          } else {
            //数据部分
            if (isNaN(parseFloat(arr1[i][j]))) {
              arr2[i][j] = null
            } else {
              arr2[i][j] = parseFloat(arr1[i][j])
              data_part[i][j] = parseFloat(arr2[i][j])
            }

            if (arr1[i][j] && (arr1[i][j].indexOf("%") > -1)) {
              this.hasPercentSymbol++
            }

          }
        }
      }


      if (this.hasPercentSymbol > 0) {
        this.form.data_type = "百分比"
      }

      var arrayNum = data_part.join(",").split(",");
      arrayNum = arrayNum.filter((item, index) => {
        if (item) {
          return item
        }
      })
      var max = Math.max.apply(null, arrayNum);
      var min = Math.min.apply(null, arrayNum);

      if (arrayNum.length > 0 && this.changeMaxTimes == 0 && this.form.yAxis_max == "dataMax") {
        if (min >= 0 && max < 1) {//是小数时，最大值初始化为1
          this.form.yAxis_max = 1;
        } else {
          this.form.yAxis_max = max;
        }
      }
      if (arrayNum.length > 0 && this.changeMinTimes == 0 && this.form.yAxis_min == "dataMin") {
        if (min >= 0 && max < 1) {//是小数时，最小值初始化为0
          this.form.yAxis_min = 0;
        } else {
          this.form.yAxis_min = min;
        }

      }
      return arr2
    },
    formatFloat(f, digit) {
      var m = Math.pow(10, digit);
      return Math.round(f * m, 10) / m;
    },
    handleReserve() {//横纵数据转换
      //需要被转置的数组
      var arr1 = this.settings.data;
      //定义一个新的数组
      var arr2 = [];
      //对新的数组进行初始化
      //因为新的数组的行数都等于原来数组列的数量

      for (var i = 0; i < arr1[0].length; i++) {
        arr2[i] = [];
      }
      //开始进行数组的转置
      for (var i = 0; i < arr1.length; i++) {
        for (var j = 0; j < arr1[i].length; j++) {
          arr2[j][i] = arr1[i][j];
        }
      }
      //对新的数组进行遍历，取出新的矩阵
      this.settings.data = arr2;
      this.hot_table.updateSettings({
        data: arr2
      });
      this.drawLine(1);
    },
    handleColorType() {
      this.hasChangeColorType = true;
    },
    handleType(type) {
      this.form.graphics_type = type;
      this.drawLine(1);
    },
    handleClick(val) {
    },
    handleChangeMax() {
      this.changeMaxTimes++;

    },
    handleChangeMin() {
      this.changeMinTimes++;
    },
    handleChangeDataType(v) {//修改数据类型
      if (this.handleChangeDataTypeFn && typeof this.handleChangeDataTypeFn === "function") {//从外面传入，
        this.handleChangeDataTypeFn();
      } else {
        this.drawLine(1);
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/packages/editable-chart/editable-chart.vue